import { render, staticRenderFns } from "./TicketEscalation.vue?vue&type=template&id=aa4dd3ac&"
import script from "./TicketEscalation.vue?vue&type=script&lang=ts&"
export * from "./TicketEscalation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports